import { useTranslation } from "react-i18next";
import { NoObjectChosen } from "../../../common/NoObjectChosen";
import { ResizableWrapper } from "../../../shared/components/ResizableWrapper";
import { AssistantSettings } from "./AssistantSettings";
import { AssistantChat } from "./AssistantChat";
import { useStorageSelectors } from "../../../app/state/storageObjectSlice/hook/use-storage-selectors";
import styles from "./styles.module.css";
import { useAppModals } from "../../../app/state/modalSlice/hook/use-app-modals";

export const Assistant = () => {
  const { selectedObject } = useStorageSelectors("assistants");
  const { handleOpenModal } = useAppModals();
  const { t } = useTranslation();

  if (selectedObject?.value === null) {
    return (
      <NoObjectChosen
        folderName={selectedObject?.friendly_name as string}
        message={t("assistants.no_object_message")}
        onClick={() =>
          handleOpenModal(
            "object_manager",
            { id: selectedObject?.id, value: "child" },
            "create_object",
          )
        }
      />
    );
  }

  return (
    <ResizableWrapper
      hasButton={true}
      leftBlock={<AssistantSettings />}
      rightBlock={<AssistantChat />}
      isCollapsible={"left"}
      leftBlockSize={40}
      rightBlockSize={60}
      rightBlockMinSize={50}
      rightClassName={styles["assistant-right-panel"]}
    />
  );
};
